export default __webpack_public_path__ + "static/media/simple-underline.1e42aa3b.svg";